var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _radialGradient, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _radialGradient2, _linearGradient11, _linearGradient12, _linearGradient13, _radialGradient3, _linearGradient14, _radialGradient4, _radialGradient5, _linearGradient15, _linearGradient16, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconMining(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "512pt",
    viewBox: "0 0 512.00087 512",
    width: "512pt",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f9f7fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0ddfc"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear0",
    gradientTransform: "matrix(.709873 .709873 -.709873 .709873 -1703.621438 -1802.760222)",
    gradientUnits: "userSpaceOnUse",
    x1: 2806.6963,
    x2: 2838.3521,
    xlinkHref: "#lg1",
    y1: -217.6916,
    y2: -167.5698
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear1",
    gradientTransform: "matrix(.709873 .709873 -.709873 .709873 -1703.621438 -1802.760222)",
    gradientUnits: "userSpaceOnUse",
    x1: 2808.6545,
    x2: 2923.9219,
    y1: 146.0975,
    y2: 146.0975
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00e7b2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4139,
    stopColor: "#1fa999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4f4a72"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear2",
    gradientTransform: "matrix(.709873 .709873 -.709873 .709873 -1703.621438 -1802.760222)",
    gradientUnits: "userSpaceOnUse",
    x1: 2720.6201,
    x2: 3303.5417,
    xlinkHref: "#lg1",
    y1: -112.0324,
    y2: -112.0324
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear3",
    gradientTransform: "matrix(.709873 .709873 -.709873 .709873 -1703.621438 -1802.760222)",
    gradientUnits: "userSpaceOnUse",
    x1: 2945.9058,
    x2: 2796.3188,
    y1: -72.8851,
    y2: -169.4165
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f0ddfc",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2889,
    stopColor: "#c8b7e0",
    stopOpacity: 0.290196
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#a595c8",
    stopOpacity: 0.592157
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8395,
    stopColor: "#8f81b8",
    stopOpacity: 0.839216
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8779b3"
  }))), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial0",
    cx: 2824.1238,
    cy: 123.1259,
    gradientTransform: "matrix(.709873 .709873 -.709873 .709873 -1703.621438 -1802.760222)",
    gradientUnits: "userSpaceOnUse",
    r: 321.3087
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f0ddfc",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4454,
    stopColor: "#eedbfb",
    stopOpacity: 0.447059
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6058,
    stopColor: "#e7d5f6",
    stopOpacity: 0.603922
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7201,
    stopColor: "#dcc9ee",
    stopOpacity: 0.721569
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8126,
    stopColor: "#cbb9e2",
    stopOpacity: 0.811765
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8918,
    stopColor: "#b5a4d3",
    stopOpacity: 0.890196
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9607,
    stopColor: "#9a8bc0",
    stopOpacity: 0.960784
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8779b3"
  }))), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3b395f",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3b395f"
  }))), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear4",
    gradientTransform: "matrix(.709873 .709873 -.709873 .709873 -1703.621438 -1802.760222)",
    gradientUnits: "userSpaceOnUse",
    x1: 2875.9358,
    x2: 2750.8022,
    xlinkHref: "#lg2",
    y1: -52.7979,
    y2: -177.9314
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear5",
    gradientUnits: "userSpaceOnUse",
    x1: 400.3135289702,
    x2: 400.3135289702,
    xlinkHref: "#lg1",
    y1: 68.3333666364,
    y2: 134.6891975016
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear6",
    gradientUnits: "userSpaceOnUse",
    x1: 274.1717335922,
    x2: 156.990343633,
    xlinkHref: "#lg2",
    y1: 383.5599554186,
    y2: 266.3785654594
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffc738"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2344,
    stopColor: "#fec33a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4454,
    stopColor: "#fbb840"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6474,
    stopColor: "#f6a649"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8426,
    stopColor: "#f08d56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e97264"
  }))), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial1",
    cx: 179.691027897,
    cy: 123.7713449672,
    gradientUnits: "userSpaceOnUse",
    r: 407.712300679,
    xlinkHref: "#lg3"
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg4"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e97264",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b53759"
  }))), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear7",
    gradientUnits: "userSpaceOnUse",
    x1: 434.6338072466,
    x2: 192.8397958998,
    xlinkHref: "#lg4",
    y1: 370.7018228348,
    y2: 270.5504637226
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear8",
    gradientUnits: "userSpaceOnUse",
    x1: 197.486047308,
    x2: 393.9833991914,
    y1: 257.5450557814,
    y2: 473.1196362542
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffc738"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e97264"
  }))), _radialGradient3 || (_radialGradient3 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial2",
    cx: 178.8272534082,
    cy: 132.3861000414,
    gradientUnits: "userSpaceOnUse",
    r: 419.1097267528
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffc738"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4647,
    stopColor: "#ffc539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "#fdbe3c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7513,
    stopColor: "#fab343"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8478,
    stopColor: "#f5a24b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9295,
    stopColor: "#f08c57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e97264"
  }))), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear9",
    gradientUnits: "userSpaceOnUse",
    x1: 372.537416643,
    x2: 181.1274394946,
    xlinkHref: "#lg4",
    y1: 443.5755168928,
    y2: 212.7389126072
  })), _radialGradient4 || (_radialGradient4 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial3",
    cx: 236.9232156262,
    cy: 267.8057409746,
    gradientUnits: "userSpaceOnUse",
    r: 160.479943466,
    xlinkHref: "#lg3"
  })), _radialGradient5 || (_radialGradient5 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial4",
    cx: 2368.6382,
    cy: 248.3264,
    gradientTransform: "matrix(-1.003922 0 0 -1.003922 2648.345633 603.357074)",
    gradientUnits: "userSpaceOnUse",
    r: 120.8131,
    xlinkHref: "#lg3"
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear10",
    gradientUnits: "userSpaceOnUse",
    x1: 339.2258791922,
    x2: 209.6835992158,
    xlinkHref: "#lg4",
    y1: 400.1551876474,
    y2: 270.612907671
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear11",
    gradientUnits: "userSpaceOnUse",
    x1: 237.6386104434,
    x2: 291.9045098392,
    xlinkHref: "#lg1",
    y1: 298.5680192908,
    y2: 352.8339186866
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m478.445312 78.488281c0 24.8125-20.117187 44.929688-44.929687 44.929688-24.816406 0-44.933594-20.117188-44.933594-44.929688 0-24.816406 20.117188-44.933593 44.933594-44.933593 24.8125 0 44.929687 20.117187 44.929687 44.933593zm0 0",
    fill: "url(#linear0)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m24.449219 504.207031-16.652344-16.65625c-13.039063-13.039062-9.320313-37.542969 8.160156-53.785156l349.445313-331.550781 44.386718 44.386718-331.550781 349.441407c-16.246093 17.480469-40.75 21.199219-53.789062 8.164062zm0 0",
    fill: "url(#linear1)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m509.417969 314.007812c-1.816407 13.234376-20.203125 15.179688-24.789063 2.636719-21.199218-57.988281-60.492187-119.296875-115.234375-174.039062-54.742187-54.742188-116.050781-94.035157-174.039062-115.234375-12.542969-4.585938-10.597657-22.972656 2.636719-24.789063 82.691406-11.355469 169.535156 14.75 233.105468 78.320313 63.570313 63.570312 89.675782 150.417968 78.320313 233.105468zm0 0",
    fill: "url(#linear2)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m430.324219 80.152344-61.695313 61.695312c.253906.253906.511719.503906.765625.757813 40.722657 40.722656 72.882813 85.074219 95.417969 128.996093v-149.824218c-9.738281-14.410156-20.960938-28.117188-33.714844-40.875-.253906-.253906-.519531-.496094-.773437-.75zm0 0",
    fill: "url(#linear3)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m377.0625 150.4375c1.371094 1.421875 2.730469 2.847656 4.078125 4.277344.640625.679687 1.28125 1.359375 1.917969 2.042968 1.402344 1.5 2.792968 3.007813 4.171875 4.519532.492187.539062.988281 1.074218 1.476562 1.613281 1.84375 2.03125 3.664063 4.070313 5.460938 6.113281.359375.40625.710937.816406 1.070312 1.226563 1.445313 1.652343 2.878907 3.304687 4.296875 4.96875.582032.679687 1.160156 1.363281 1.738282 2.042969 1.222656 1.449218 2.433593 2.898437 3.640624 4.347656.558594.679687 1.125 1.355468 1.683594 2.035156 1.40625 1.71875 2.800782 3.441406 4.183594 5.167969.292969.367187.59375.730469.886719 1.097656 1.65625 2.082031 3.292969 4.171875 4.90625 6.265625.449219.582031.890625 1.164062 1.335937 1.746094 1.179688 1.539062 2.347656 3.082031 3.503906 4.625.535157.714844 1.066407 1.425781 1.59375 2.140625 1.113282 1.507812 2.214844 3.011719 3.308594 4.523437.460938.632813.925782 1.269532 1.382813 1.90625 1.519531 2.117188 3.019531 4.234375 4.496093 6.355469.078126.113281.152344.226563.230469.339844 1.394531 2.011719 2.769531 4.027343 4.125 6.042969.445313.667968.886719 1.332031 1.328125 1.996093 1 1.503907 1.992188 3.011719 2.972656 4.519531.464844.714844.929688 1.433594 1.390626 2.148438 1.035156 1.613281 2.058593 3.226562 3.066406 4.839844.335937.539062.679687 1.074218 1.015625 1.613281 1.324219 2.132813 2.625 4.265625 3.90625 6.398437.277343.46875.550781.933594.824219 1.398438 1.003906 1.6875 1.996093 3.375 2.96875 5.058594.410156.710937.816406 1.417968 1.21875 2.128906.859374 1.503906 1.707031 3.007812 2.542968 4.511719.382813.6875.769532 1.378906 1.148438 2.070312 1.003906 1.828125 1.992187 3.65625 2.964844 5.484375.167968.316406.339843.636719.507812.953125 1.128906 2.136719 2.230469 4.269531 3.316406 6.40625.308594.609375.609375 1.214844.914063 1.824219.777343 1.554688 1.546875 3.105469 2.300781 4.65625.351562.726562.699219 1.449219 1.046875 2.171875.734375 1.53125 1.457031 3.0625 2.164063 4.59375.292968.628906.589843 1.261719.878906 1.890625.976562 2.125 1.933594 4.253906 2.859375 6.375.09375.207031.179687.414062.269531.621094.835938 1.921875 1.648438 3.835937 2.445312 5.75.28125.675781.554688 1.347656.832032 2.019531.609375 1.488281 1.207031 2.976563 1.796875 4.460937.277343.707032.558593 1.414063.832031 2.117188.628906 1.621094 1.238281 3.234375 1.839844 4.847656.1875.503906.382812 1.007813.566406 1.511719.054688.148437.109375.292969.164062.4375 2.671876 7.308594 10.027344 9.6875 16.0625 7.792969-.175781-77.628906-31.632812-157.636719-93.5625-219.566406-61.929687-61.929688-141.9375-93.386719-219.566406-93.5625-1.898437 6.035156.484375 13.390624 7.792969 16.0625.144531.050781.289063.109374.433594.160156.507812.1875 1.015625.382812 1.523437.570312 1.609375.601563 3.21875 1.210938 4.835938 1.839844.707031.273438 1.414062.554688 2.125.832031 1.480468.585938 2.964844 1.183594 4.453125 1.792969.675781.277344 1.351562.550781 2.023437.835938 1.914063.792968 3.824219 1.605468 5.738282 2.441406.210937.089844.421874.179687.636718.269531 2.121094.929687 4.246094 1.886719 6.371094 2.859375.632812.289062 1.265625.589844 1.898438.882812 1.527343.707032 3.054687 1.429688 4.585937 2.160157.722656.347656 1.449219.699219 2.175781 1.050781 1.550782.753906 3.097656 1.519531 4.648438 2.300781.613281.304688 1.222656.605469 1.832031.914063 2.132813 1.082031 4.269531 2.183594 6.402344 3.3125.320312.167968.640625.34375.960937.515625 1.828125.96875 3.652344 1.957031 5.476563 2.960937.691406.378906 1.382812.765625 2.078125 1.148438 1.5.835937 3.003906 1.683594 4.507812 2.542968.707032.402344 1.417969.808594 2.125 1.21875 1.6875.972657 3.371094 1.960938 5.054688 2.960938.46875.28125.9375.550781 1.40625.832031 2.132812 1.277344 4.265625 2.582031 6.398437 3.902344.539063.335937 1.078125.679687 1.617188 1.019531 1.613281 1.007813 3.222656 2.027344 4.832031 3.0625.71875.460938 1.4375.925782 2.15625 1.394532 1.503906.976562 3.007812 1.96875 4.511719 2.96875.664062.441406 1.332031.882812 2 1.332031 2.015625 1.355469 4.027343 2.722656 6.035156 4.117187.117187.082032.230469.160156.347656.238282 2.121094 1.472656 4.238281 2.976562 6.355469 4.492187.636719.457031 1.273438.921875 1.910156 1.382813 1.507813 1.09375 3.015625 2.195312 4.519532 3.308593.714843.53125 1.429687 1.0625 2.140624 1.597657 1.542969 1.152343 3.085938 2.320312 4.621094 3.5.585938.445312 1.171875.886718 1.753906 1.335937 2.089844 1.617187 4.179688 3.25 6.261719 4.90625.367188.292969.734375.59375 1.101563.890625 1.722656 1.378906 3.445312 2.773438 5.164062 4.183594.679688.554687 1.355469 1.121094 2.035156 1.683594 1.449219 1.203124 2.902344 2.414062 4.347657 3.640624.679687.574219 1.363281 1.152344 2.042969 1.734376 1.660156 1.417968 3.316406 2.851562 4.96875 4.296874.410156.359376.820312.710938 1.226562 1.070313 2.046875 1.796875 4.082031 3.621094 6.109375 5.460937.542969.488282 1.078125.988282 1.617187 1.480469 1.511719 1.378907 3.019532 2.765625 4.523438 4.171875.679688.636719 1.359375 1.273438 2.039062 1.914063 1.429688 1.351562 2.855469 2.710937 4.277344 4.078125.617188.59375 1.238282 1.1875 1.855469 1.785156 2 1.941406 3.992187 3.898438 5.980469 5.882812 1.980468 1.984376 3.941406 3.980469 5.882812 5.980469.59375.617188 1.183594 1.238281 1.777344 1.855469zm0 0",
    fill: "url(#radial0)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m341.195312 126.53125v92.707031l68.59375-72.640625-44.386718-44.386718-24.375 23.019531zm0 0",
    fill: "url(#linear4)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m385.46875 170.804688-44.273438-44.273438c-9.042968-9.042969-9.042968-23.703125 0-32.746094l41.21875-41.214844c9.039063-9.042968 23.699219-9.042968 32.746094 0l44.273438 44.273438c9.042968 9.042969 9.042968 23.703125 0 32.746094l-41.21875 41.214844c-9.042969 9.042968-23.703125 9.042968-32.746094 0zm0 0",
    fill: "url(#linear5)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m44.925781 424.640625 51.855469 51.855469 263.242188-277.449219c-21.402344-12.246094-45.164063-20.828125-70.441407-24.894531l-253 240.046875c2.023438 3.660156 4.828125 7.144531 8.34375 10.441406zm0 0",
    fill: "url(#linear6)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m465.851562 381.316406c0 115.898438-419.703124 115.898438-419.703124 0 0-115.898437 93.953124-209.851562 209.851562-209.851562s209.851562 93.953125 209.851562 209.851562zm0 0",
    fill: "url(#radial1)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m317.609375 180.664062v284.152344c80.804687-9.214844 148.242187-37.042968 148.242187-83.5 0-94.457031-62.410156-174.332031-148.242187-200.652344zm0 0",
    fill: "url(#linear7)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m176.429688 194.507812v267.578126c50.632812 8.195312 108.507812 8.195312 159.140624 0v-267.578126c0-15.003906-9.882812-28.261718-24.300781-32.421874-17.609375-5.078126-36.136719-7.789063-55.269531-7.789063s-37.660156 2.710937-55.269531 7.789063c-14.417969 4.160156-24.300781 17.417968-24.300781 32.421874zm0 0",
    fill: "url(#linear8)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m46.644531 372.457031c.105469-1.148437-1.367187-1.710937-2.023437-.761719-1.820313 2.636719-3.585938 5.332032-5.292969 8.085938-74.050781 119.480469 507.394531 119.480469 433.34375 0-1.707031-2.753906-3.472656-5.449219-5.292969-8.085938-.65625-.949218-2.128906-.386718-2.019531.761719 7.046875 75.96875-425.765625 75.96875-418.714844 0zm0 0",
    fill: "url(#radial2)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m465.738281 384.429688-136.425781-136.429688c-18.355469-19.515625-44.40625-31.703125-73.3125-31.703125-55.578125 0-100.632812 45.054687-100.632812 100.632813 0 28.902343 12.191406 54.957031 31.703124 73.3125l77.921876 77.921874c99.949218-1.578124 197.164062-29.492187 200.746093-83.734374zm0 0",
    fill: "url(#linear9)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m356.632812 316.929688c0 55.578124-45.054687 100.632812-100.632812 100.632812s-100.632812-45.054688-100.632812-100.632812c0-55.578126 45.054687-100.632813 100.632812-100.632813s100.632812 45.054687 100.632812 100.632813zm0 0",
    fill: "url(#radial3)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m332.054688 316.929688c0 42.003906-34.050782 76.054687-76.054688 76.054687s-76.054688-34.050781-76.054688-76.054687c0-42.003907 34.050782-76.054688 76.054688-76.054688s76.054688 34.050781 76.054688 76.054688zm0 0",
    fill: "url(#radial4)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m356.488281 322.304688-51.289062-51.289063c-12.285157-13.160156-29.777344-21.398437-49.199219-21.398437-37.175781 0-67.308594 30.136718-67.308594 67.3125 0 19.421874 8.234375 36.910156 21.394532 49.199218l51.289062 51.289063c51.300781-2.699219 92.414062-43.8125 95.113281-95.113281zm0 0",
    fill: "url(#linear10)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m323.3125 316.929688c0 37.175781-30.136719 67.3125-67.3125 67.3125s-67.308594-30.136719-67.308594-67.3125c0-37.175782 30.132813-67.308594 67.308594-67.308594s67.3125 30.132812 67.3125 67.308594zm0 0",
    fill: "url(#linear11)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMining);
export default __webpack_public_path__ + "static/media/icon-mining.6618f5d12063509b55a48c9d84d1589c.svg";
export { ForwardRef as ReactComponent };